import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </Tag>
  );
};

export const SectionHeading = ({ eyebrow, title, copy, align = "left", testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    {eyebrow && (
      <Reveal>
        <p className="mono text-xs tracking-[0.35em] uppercase text-[var(--green)] mb-5">{eyebrow}</p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight">{title}</h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base md:text-lg text-[var(--muted)] leading-relaxed">{copy}</p>
      </Reveal>
    )}
  </div>
);
